import {createContext, Dispatch, SetStateAction} from "react";

interface IValidationContext {
   validateOn: boolean,
   tabs?: string[],
   setTabs?:  Dispatch<SetStateAction<string[]>>
}

const ValidationContext = createContext<IValidationContext>({ validateOn: false, tabs: [], setTabs: () => undefined })
export default ValidationContext;